import { FC } from 'react';
import { useHistory } from 'react-router';
import { RadabankOnboardingContent } from 'components/RadabankCard';
import { ArrowBackButton, CustomButton } from 'components/shared';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { ROUTER_URL } from 'utils/enums';
import { FirebaseAnalytics } from 'utils/services';

interface RadabankRestorePasswordBannerProps {
	title: string;
	description?: string | string[];
}

export const RadabankRestorePasswordBanner: FC<RadabankRestorePasswordBannerProps> = ({ title, description }) => {
	const history = useHistory();

	const handleClickRedirectMain = () => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.AUTH.PASSWORD_RESTORE_RB,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_HOME
		);
		history.replace(ROUTER_URL.AUTH_CHECK_PHONE);
	};

	return (
		<div className="host-card-page-color-primary">
			<ArrowBackButton onClick={handleClickRedirectMain} />
			<RadabankOnboardingContent title={title} description={description} />
			<CustomButton label="На головну" color="secondary" onClick={handleClickRedirectMain} />
		</div>
	);
};
